/**
 * Indicador de espera único do app: círculo laranja com ícones de obra se
 * revezando (capacete → martelo → tijolos → rolo). Os desenhos são os do
 * lucide (24×24, traço 2), guardados aqui como dados para que o React
 * (`components/CapitalSpinner`) e o SweetAlert (`showLoadingAlert`, que só
 * aceita HTML) desenhem exatamente o mesmo spinner. Animação em
 * `assets/css/animations.css` (`.cc-spinner`).
 */
export type NoSvg = readonly [tag: 'path' | 'rect', attrs: Readonly<Record<string, string>>];

export const ICONES_OBRA: readonly (readonly NoSvg[])[] = [
    // hard-hat
    [
        ['path', { d: 'M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5' }],
        ['path', { d: 'M14 6a6 6 0 0 1 6 6v3' }],
        ['path', { d: 'M4 15v-3a6 6 0 0 1 6-6' }],
        ['rect', { x: '2', y: '15', width: '20', height: '4', rx: '1' }],
    ],
    // hammer
    [
        ['path', { d: 'm15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9' }],
        ['path', { d: 'm18 15 4-4' }],
        [
            'path',
            {
                d: 'm21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5',
            },
        ],
    ],
    // brick-wall
    [
        ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
        ['path', { d: 'M12 9v6' }],
        ['path', { d: 'M16 15v6' }],
        ['path', { d: 'M16 3v6' }],
        ['path', { d: 'M3 15h18' }],
        ['path', { d: 'M3 9h18' }],
        ['path', { d: 'M8 15v6' }],
        ['path', { d: 'M8 3v6' }],
    ],
    // paint-roller
    [
        ['rect', { width: '16', height: '6', x: '2', y: '2', rx: '2' }],
        ['path', { d: 'M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2' }],
        ['rect', { width: '4', height: '6', x: '8', y: '16', rx: '1' }],
    ],
];

/** Ícone ocupa ~55% do círculo; abaixo de 24 px cresce para 70% e o traço engrossa, para não virar um ponto. */
export const medidasSpinner = (size: number) => ({ icone: Math.round(size * (size < 24 ? 0.7 : 0.56)), traco: size < 24 ? 2.6 : 2 });

/** O mesmo spinner em HTML puro, para o SweetAlert. */
export function capitalSpinnerHtml(size = 56): string {
    const { icone, traco } = medidasSpinner(size);
    const svgs = ICONES_OBRA.map(
        (nos) =>
            `<svg width="${icone}" height="${icone}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${traco}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${nos
                .map(
                    ([tag, attrs]) =>
                        `<${tag} ${Object.entries(attrs)
                            .map(([k, v]) => `${k}="${v}"`)
                            .join(' ')}/>`,
                )
                .join('')}</svg>`,
    ).join('');
    return `<span class="cc-spinner" role="status" aria-label="Carregando" style="width:${size}px;height:${size}px">${svgs}</span>`;
}
